import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {applicantLogin} from '../../../auth/core/_requests'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useAuth} from '../../../auth/core/Auth'

import { useNavigate } from "react-router-dom";
import { StatusErrorMessage } from '../../../../components/widgets'
import { getErrorMessage } from '../../../../components/helpers'

const loginSchema = Yup.object().shape({
  email: Yup.string().trim()
    .email('Valid email required')
    .min(3, 'Minimum 3 symbols')
    .max(200)
    .required('Email is required'),
  password: Yup.string().trim()
    .min(8, 'Minimum 8 symbols')
    .max(20)
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function CompanyLogin() {

  const navigate = useNavigate();
      
  const {saveAuth} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setStatus('');
      setSubmitting(true);

      async function doLogin(data: any) {
        await applicantLogin(data.email, data.password)
        .then( res => {
          // check for success
          if (! (res && res.loggedIn)) {
            setStatus((res && res.message) ? res.message : 'Wrong username/password');
            return;
          }   
          
          saveAuth( {                            
            email: res.email,
            password: values.password,
            loggedIn: false,
            id: -1,
            isSetsco: false,                             
          })

          navigate("/auth/otp");
        })                    
        .catch( err => {
          saveAuth(undefined)
          const msg = getErrorMessage(err);                 
          if (msg.match(/401/)) {
            setStatus('Wrong username/password');
          } else {
            setStatus(msg);
          }         
        })          
        .finally( () => {
          setSubmitting(false)          
        })
      }

      await doLogin(values);            
    },
  })

  return (
  <>
  <div>
    <div className="p-6 text-center" style={{marginTop: '-60px'}}>
      <img src={toAbsoluteUrl('/media/brand/Setsco_BrandSig_2D_white.png')} className="h-80px" alt='setsco' />
    </div>        
    <form
      className="form w-100 w-lg-400px bg-white rounded-4 overflow-hidden"
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className="bg-primary fs-6 text-white p-6 text-center">
        CERTIFICATION APPLICATION & MANAGEMENT SYSTEM
      </div>
      <div className="p-10 d-flex flex-column gap-8 mb-2">                            
        <div className="text-center text-primary fw-bold fs-1">
          Sign In
        </div>

        <div className='fv-row'>                
          <input
            placeholder='Username'
            {...formik.getFieldProps('email')}
            className={clsx(
                'form-control bg-transparent',
                {'is-invalid': formik.touched.email && formik.errors.email},
                {'is-valid': formik.touched.email && !formik.errors.email,}
            )}
            type='email'
            name='email'
            autoComplete='off'
          />
          {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
          )}
        </div>

        <div className='fv-row'>                
          <input
            placeholder='Password'
            type='password'
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
                'form-control bg-transparent',
                {'is-invalid': formik.touched.password && formik.errors.password,},
                {'is-valid': formik.touched.password && !formik.errors.password,}
            )}
          />
          {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
                <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
          )}
        </div>
        
        <StatusErrorMessage status={formik.status} />

        <div className="d-flex flex-stack flex-wrap gap-3 justify-content-start align-items-center mt-4">
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary px-10'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {(!formik.isSubmitting) && <span className='indicator-label'>Continue</span>}
            {formik.isSubmitting && (
            <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
            )}
          </button>                
          <Link to='/auth/forgot-password' className="link-primary">
            Reset/Forgot Password ?
          </Link>        
          <div />        
        </div>    
      </div>

      <Link to='/auth/createaccount'>
        <button
            type='button'
            id='kt_sign_in_createaccount_btns'
            className="btn btn-secondary w-100 rounded-0 py-6"                
        >
                CREATE AN ACCOUNT
        </button>
      </Link>
    </form>
  </div>            
  </>
  )
}
